import { featuredCustomerLogos } from '../constants/featured-customer-logos'
import type { FeaturedBrandLogo } from '../types/featured-customer-logos-types';
import { cn } from '@/lib/utils';
import { CUSTOMER_LOGO_GRID_SIZE } from '../types/customer-logo-grid-enums';

interface CustomerLogoGridProps {
  logos?: readonly FeaturedBrandLogo[];

  className?: string;
  label?: string;
  centered?: boolean;
  size?: CUSTOMER_LOGO_GRID_SIZE;
}

const sizeConfig = {
  sm: {
    cell: 'h-8',
    image: 'h-5 w-auto max-w-[88px]',
    gap: 'gap-x-6 gap-y-4',
  },
  md: {
    cell: 'h-10',
    image: 'h-6 w-auto max-w-[100px] md:h-7 md:max-w-[110px]',
    gap: 'gap-x-8 gap-y-5 sm:gap-x-10',
  },
} as const;

export function CustomerLogoGrid({
  logos = featuredCustomerLogos,
  className,
  label = 'Trusted by 1,000+ Shopify brands',
  centered = false,
  size = CUSTOMER_LOGO_GRID_SIZE.MD,

}: CustomerLogoGridProps) {
  const config = sizeConfig[size];

  return (
    <div className={cn('space-y-3', centered && 'text-center', className)}>
      {label ? (
        <p
          className={cn(
            'text-xs font-medium uppercase tracking-[0.08em] text-content-secondary',
            centered && 'text-center'
          )}
        >
          {label}
        </p>
      ) : null}
      <div
        className={cn(
          'grid max-w-md grid-cols-3 items-center',
          centered ? 'mx-auto justify-items-center' : 'justify-items-start',
          config.gap
        )}
      >
        {logos.map(logo => (
          <div key={logo.src} className={cn('flex items-center justify-center', config.cell)}>
            <img
              src={logo.src}
              alt={logo.alt}
              className={cn(
                'object-contain invert dark:invert-0',
                config.image
              )}
            />
          </div>
        ))}
      </div>
    </div>
  );
}
